import React, { useState } from 'react';
import { Icon, Text, BadgeStatut } from '../../Atoms';
import getMessageRemboursement, {
  getRemboursementStatut,
  BADGE_LABEL_BY_STATUT
} from '../../Utils/remboursementMessage';
import {SoinsDateActe} from "../../Atoms/SoinsDateActe";

function OrganismRemboursement(props) {
  const [sort, setsort] = useState(true);
  const { numero, reglement, ligne } = props.data;
  const statutRemboursement = getRemboursementStatut(reglement);
  const messageRemboursement = getMessageRemboursement(
    reglement,
    ligne[0]?.ayantDroit,
    statutRemboursement
  );
  const convertDate = (dateString) => {
    return dateString;
  };
  return (
    <>
        <div
        className="remboursement-organism-container remboursement-organism-mobile-display"
        onClick={() => setsort(!sort)}
      >
        <div className="remboursement-organism-header-container">
          <div className="remboursement-organism-telechargement-icon-container">
            <Icon
              icon="Telechargement"
              size="20px"
              onClick={() => props.downloadDocument(numero)}
              style={{ cursor: 'pointer' }}
            />
          </div>
          <div className="remboursement-organism-body">
            <div className="remboursement-organism-top-row">
              <div className="remboursement-organism-name-badge">
                <Text
                  text={ligne[0]?.ayantDroit}
                  className="remboursement-desktop-text-bold remboursement-organism-benfit-name"
                />

                <SoinsDateActe lines={ligne} />

                <BadgeStatut
                  statut={statutRemboursement}
                  variant="filled"
                  text={BADGE_LABEL_BY_STATUT[statutRemboursement]}
                />
              </div>
              <div className="remboursement-organism-amount-chevron">
                <Text
                  text={`${reglement.totalRembCGRM}€`}
                  className="remboursement-desktop-text-bold"
                />
                <Icon
                  icon={sort ? 'Sort' : 'SortTop'}
                  size="13px"
                  className="remboursement-organism-description-icon"
                />
              </div>
            </div>
            <Text
              text={messageRemboursement}
              className="remboursement-desktop-text remboursement-statut-message-text"
            />
          </div>
        </div>
        {!sort /* CE MAP SERT POUR LA VERSION MOBILE */ &&
          <>
            {
              ligne.map((element, index) => (
                <div
                  className="remboursement-organism-info-container"
                  key={String(index)}
                >
                  <div className="remboursement-organism-info-content">
                    <div
                      style={{
                        width: "40%",
                        wordBreak: "break-word"
                      }} 
                      className="remboursement-molecule-container"
                    >
                      <Text
                        text="Frais"
                        className="remboursement-desktop-text-bold"
                      />
                      <Text
                        text={`${element.libelle}`}
                        className="remboursement-desktop-text"
                      />
                    </div>
                    <div 
                      className="remboursement-molecule-container"
                      style={{
                        width: "10%"
                      }} 
                    >
                      <Text
                        text="Base SS"
                        className="remboursement-desktop-text-bold"
                      />
                      <Text
                        text={`${element.baseSS}`}
                        className="remboursement-desktop-text"
                      />
                    </div>
                    <div 
                      className="remboursement-molecule-container"
                      style={{
                        width: "10%"
                      }}
                    >
                      <Text
                        text="Taux SS"
                        className="remboursement-desktop-text-bold"
                      />
                      <Text
                        text={`${element.tauxSS}%`}
                        className="remboursement-desktop-text"
                      />
                    </div>
                    <div 
                      className="remboursement-molecule-container"
                      style={{
                        width: "25%"
                      }}
                    >
                      <Text
                        text="Remboursement SS"
                        className="remboursement-desktop-text-bold"
                      />
                      <Text
                        text={`${element.rembSS}€`}
                        className="remboursement-desktop-text"
                      />
                    </div>
                  </div>
                </div>
              ))
            }
            <Text 
              className="remboursement-desktop-text mt-12"
              text="Veuillez noter que le délai peut prendre un peu de temps avant d'apparaître sur le compte bancaire"
            />
          </>
          }
      </div>
       <div
        className={
          !sort
            ? 'remboursement-desktop-organism-container remboursement-organism-desktop-display'
            : 'remboursement-desktop-organism-container-center remboursement-organism-desktop-display'
        }
      >
        
        <div className="remboursement-desktop-organism-content-container">
          <div className="remboursement-organism-top-row">
            <div className="remboursement-organism-name-badge">
              <Text
                text={ligne[0]?.ayantDroit}
                className="remboursement-desktop-text-bold"
              />
              <SoinsDateActe lines={ligne} />
              <BadgeStatut
                statut={statutRemboursement}
                variant="filled"
                text={BADGE_LABEL_BY_STATUT[statutRemboursement]}
              />
            </div>
            <div className="remboursement-organism-amount-chevron">
              <Text
                text={`${reglement.totalRembCGRM}€`}
                className="remboursement-desktop-text-bold"
              />
              <Icon
                icon={sort ? 'Sort' : 'SortTop'}
                size="20px"
                style={{ cursor: 'pointer' }}
                className="remboursement-desktop-organism-description-icon"
                onClick={() => setsort(!sort)}
              />
            </div>
          </div>
          <Text
            text={messageRemboursement}
            className="remboursement-desktop-text-2 remboursement-statut-message-text"
          />
          {!sort &&
            <>
              {ligne.map((element, index) => (
              <div
                className="remboursement-desktop-organism-info-container"
                key={String(index)}
              >
                <div
                  style={{
                    width: '40%',
                    wordBreak: 'break-word',
                  }}
                >
                  <span className="remboursement-desktop-text-bold">
                    {element.libelle}
                  </span>
                  <div className="remboursement-desktop-text mt-6">
                      {`Date du soin: ${convertDate(element.dateActe?.shortDate)}`}
                  </div>
                </div>
                <div
                  className="remboursement-desktop-organism-info-content"
                  style={{ width: '40%' }}
                >
                  <div className="remboursement-desktop-molecule-container">
                    <Text text="Frais" className="remboursement-desktop-text" />
                    <Text
                      text={`${element.fr}€`}
                      className="remboursement-desktop-text-bold"
                    />
                  </div>
                  <div className="remboursement-desktop-molecule-container">
                    <Text
                      text="Base SS"
                      className="remboursement-desktop-text"
                    />
                    <Text
                      text={`${element.baseSS}€`}
                      className="remboursement-desktop-text-bold"
                    />
                  </div>
                  <div className="remboursement-desktop-molecule-container">
                    <Text
                      text="Taux SS"
                      className="remboursement-desktop-text"
                    />
                    <Text
                      text={`${element.tauxSS}%`}
                      className="remboursement-desktop-text-bold"
                    />
                  </div>
                  <div className="remboursement-desktop-molecule-container">
                    <Text
                      text="Remboursement SS"
                      className="remboursement-desktop-text"
                    />
                    <Text
                      text={`${element.rembSS}€`}
                      className="remboursement-desktop-text-bold"
                    />
                  </div>
                </div>
              </div>
            ))}
            <Text 
              className="remboursement-desktop-text mt-12"
              text="Veuillez noter que le délai peut prendre un peu de temps avant d'apparaître sur le compte bancaire"
            />
            </>
            }
        </div>
      </div>
    </>
  );
}

export default OrganismRemboursement;
